export type PlanId = 'free' | 'premium' | 'enterprise'

export type PlanDefinition = {
  id: PlanId
  name: string
  priceLabel: string
  priceCents: number | null
  description: string
  features: string[]
  cta: {
    label: string
    href: string
    isButton?: boolean
    disabled?: boolean
  }
  highlight?: boolean
}

export const PLANS: PlanDefinition[] = [
  {
    id: 'free',
    name: 'Free',
    priceLabel: '$0/mo',
    priceCents: 0,
    description: 'Great for the starving Techie',
    features: [
      'Access to Free Courses',
      'Static unchanging Content',
      'Community support'
    ],
    cta: {
      label: 'Current Plan',
      href: '#',
      disabled: true,
    },
  },
  {
    id: 'premium',
    name: 'Premium',
    priceLabel: '$25.00/mo',
    priceCents: 2500,
    description: 'Unlock all content',
    features: [
      'Access all courses & labs',
      'Get the latest content launches',
      'Prioritized learning'
    ],
    cta: {
      label: 'Choose Premium',
      href: '/checkout',
      isButton: true,
    },
    highlight: true,
  },
  {
    id: 'enterprise',
    name: 'Enterprise',
    priceLabel: 'Contact us',
    priceCents: null,
    description: 'Purpose-built for teams and orgs',
    features: [
      'All premium features',
      'Dedicated support',
      'Custom onboarding & licensing'
    ],
    cta: {
      label: 'Contact Sales',
      href: '/contact',
      isButton: true,
    },
  },
]

export function getPlan(planId: PlanId = 'premium') {
  return PLANS.find((plan) => plan.id === planId) || PLANS[1]
}

export function isPlanId(value: unknown): value is PlanId {
  return value === 'free' || value === 'premium' || value === 'enterprise'
}
